import { resolvePath, useMatch, useNavigate } from "react-router";
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";

import "./header.scss";
import { Fragment, useState } from "react";
import { ChevronRight } from "@mui/icons-material";


export default function Header({ route }) {
  const navigate = useNavigate();
  return (
    <AppBar position="static" sx={{ zIndex: 100 }}>
      <Toolbar className="nav">
        <Typography
          variant="h4"
          component="div"
          className="nav-brand"
          onClick={() => navigate("/")}
        >
          DeepPEP
        </Typography>
        {route.children.map((subRoute, index) =>
          subRoute.children ? (
            <NavMenu basePath={route.path} route={subRoute} key={index} />
          ) : (
            <NavItem basePath={route.path} route={subRoute} key={index} />
          )
        )}
      </Toolbar>
    </AppBar>
  );
}

function NavMenu({ basePath, route }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const path = resolvePath(route.path, basePath).pathname;
  const matched = Boolean(useMatch({ path, end: false }));
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="nav-menu">
      <div
        className={"nav-item" + (matched && !open ? " active" : "")}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {route.icon}
        {route.title}
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          sx: { backgroundColor: "primary.dark" },
        }}
      >
        {route.children
          .filter(route => !route.index)
          .map((subRoute, index) => (
            <NavMenuItem route={subRoute} basePath={path} key={index} />
          ))}
      </Menu>
    </div>
  );
}

function NavItem({ route, basePath }) {
  const navigate = useNavigate();
  const path = resolvePath(route.path ?? "", basePath).pathname;
  const matched = Boolean(useMatch(path));

  if (route.title !== "Result") {
    return (
      <div
        className={
          "nav-item" + (matched && route.title !== "Result" ? " active" : "")
        }
        onClick={() => navigate(path)}
      >
        {route.icon}
        {route.title}
      </div>
    );
  } else {
    return null;
  }
}

function NavMenuItem({ route, basePath }) {
  const navigate = useNavigate();
  const path = resolvePath(route.path, basePath).pathname;
  const matched = Boolean(useMatch({ path, end: false }));

  return (
    <MenuItem
      onClick={() => navigate(path)}
      sx={{
        color: matched ? "secondary.light" : "primary.contrastText",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
        },
      }}
    >
      <Fragment>
        <ListItemIcon>
          <ChevronRight
            sx={{
              color: matched ? "secondary.main" : "#FFF4",
              animation: matched ? "move-h 2s ease-in-out infinite" : null,
            }}
            className="moving-horizon"
          />
        </ListItemIcon>
        {route.title}
      </Fragment>
    </MenuItem>
  );
}
